import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuditLogPage } from "@/features/audit/components/AuditLogPage";
import { sessionQuery } from "@/features/auth/queries";
import { directoryQuery } from "@/features/directory/queries";

/**
 * User and role-grant audit — admins and super admins only
 * (`audit.read.user_management`, a reviewer holds no grant of it at all).
 * A separate route from `/audit/master-data` rather than a third tab on
 * it: DEE-36's second acceptance criterion is that domain segregation be
 * visible in the *navigation*, and two routes each gated by their own
 * permission is what makes `PrimaryNav`'s existing `canAnywhere` filter
 * produce that for free — a reviewer with no `audit.read.user_management`
 * grant never sees this link at all.
 */
export const Route = createFileRoute("/_authed/audit/user-management")({
  staticData: { crumbs: [{ key: "nav.audit.userManagement" }] },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(sessionQuery);
    await context.queryClient.ensureQueryData(directoryQuery());
  },
  component: UserManagementAudit,
});

function UserManagementAudit() {
  const { t } = useTranslation();
  const { data: directory } = useSuspenseQuery(directoryQuery());

  return (
    <AuditLogPage
      title={t("audit.userManagement.title")}
      description={t("audit.userManagement.description")}
      domainOptions={[{ value: "user_management", label: t("audit.domain.userManagement") }]}
      emptyTitle={t("audit.empty.title")}
      emptyBody={t("audit.empty.body")}
      directory={directory}
      masterTypeIndex={undefined}
    />
  );
}
